import { createSlice } from '@reduxjs/toolkit';
import getColorsAction from '../../actions/colorsActions';
import { ColorsState } from './ColorsSlice.types';
import { Color } from '../../actions/colorsActions/types';

const initialState: ColorsState = {
    pending: false,
    colorNames: {},
    basicColors: [],
    additionalColors: [],
    colorBaseColorMap: {},
};

const baseOrder = ['Magenta', 'Orange', 'Yellow', 'Green', 'Slate', 'Blue', 'Lavender'];
const basicOrder = ['Yellow', 'Light Green', 'Green'];

function getBasicPalette(items: Color[]): Color[] {
    return basicOrder
        .map((bn) => items.find((c) => c.isBasic && c.name === bn))
        .filter((c): c is Color => c != null);
}

function getAdditionalPalette(items: Color[]): Color[][] {
    const shadeLevels = [1, 2, 3];
    return shadeLevels.map((level) =>
        baseOrder
            .map((bn) => items.find((c) => !c.isBasic && c.name === `${bn} ${level}`))
            .filter((c): c is Color => c != null)
    );
}

export const colorsSlice = createSlice({
    name: 'colors',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getColorsAction.pending, (state) => {
                state.pending = true;
            })
            .addCase(getColorsAction.fulfilled, (state, action) => {
                state.pending = false;
                const items = action.payload?.data || [];
                const basic: Color[] = getBasicPalette(items);
                const additional: Color[][] = getAdditionalPalette(items);

                state.basicColors = basic;
                state.additionalColors = additional;
                state.fetchedAt = Date.now();
            })
            .addCase(getColorsAction.rejected, (state) => {
                state.pending = false;
            });
    },
});

export default colorsSlice.reducer;
